import { withNaming } from '@bem-react/classname';

export const cn = withNaming({ n: 'i-', e: '__', m: '--', v: '_' });
